/* eslint-disable dot-notation */
import { parseFromString, unescape } from './htmlParser';

const updateTableColumnsWidth = (content) => {
  // Fix for table column resizing.
  const parsedHtml = parseFromString(content);
  const tableElements = parsedHtml.getElementsByTagName('table');

  Array.prototype.forEach.call(tableElements, (table) => {
    const wrapperWidth =
      table.attributes['data-wrapperwidth'] && table.attributes['data-wrapperwidth'].value
        ? parseInt(table.attributes['data-wrapperwidth'].value, 10)
        : 0;
    const tableWidth =
      table.attributes['data-tablewidth'] && table.attributes['data-tablewidth'].value
        ? parseInt(table.attributes['data-tablewidth'].value, 10)
        : wrapperWidth;

    if (tableWidth && wrapperWidth) {
      const relativeTableWidth = ((tableWidth * 100) / wrapperWidth).toFixed(2);
      // eslint-disable-next-line no-param-reassign
      table.style.width = `${relativeTableWidth}%`;
      // eslint-disable-next-line no-param-reassign
      table.style.minWidth = 'unset';

      const parent = table.parentNode;
      // Create a wrapping div around the table for responsive behaviour.
      const wrapper = document.createElement('div');
      wrapper.classList.add('pm-table-wrapper');
      parent.replaceChild(wrapper, table);
      wrapper.appendChild(table);

      Array.prototype.forEach.call(table.rows, (row) => {
        const cellElements = row.children;
        const cellsWithColWidth = Array.prototype.filter.call(
          cellElements,
          (cell) => cell.attributes['data-colwidth']?.value || cell.attributes['colwidth']?.value
        );

        // Calculating column width for columns without data-colwidth attribute.
        const knownColWidthsSum = cellsWithColWidth.reduce((accum, cell) => {
          const colWidthValue =
            cell.attributes['data-colwidth']?.value || cell.attributes['colwidth']?.value;

          if (colWidthValue.includes(',')) {
            // Handling column width calculation for merged cells.
            const widthArr = colWidthValue.split(',');
            const cellWidth = widthArr.reduce((acc, width) => acc + parseInt(width, 10), 0);

            return accum + cellWidth;
          }
          return accum + parseInt(colWidthValue, 10);
        }, 0);
        const remainingTableWidth = tableWidth - knownColWidthsSum;
        const columnsWithoutWidth =
          cellsWithColWidth.length !== cellElements.length
            ? cellElements.length - cellsWithColWidth.length
            : cellElements.length;
        const columnWidth = remainingTableWidth / columnsWithoutWidth;

        Array.prototype.forEach.call(cellElements, (cell) => {
          const colWidthValue =
            cell.attributes['data-colwidth']?.value || cell.attributes['colwidth']?.value;

          if (colWidthValue) {
            let cellWidth;
            if (colWidthValue.includes(',')) {
              // Handling column width calculation for merged cells.
              const widthArr = colWidthValue.split(',');
              cellWidth = widthArr.reduce((acc, width) => acc + parseInt(width, 10), 0);
            } else {
              cellWidth = parseInt(colWidthValue, 10);
            }

            // If data-colwidth attribute is available, set column width.
            const relativeCellWidth = ((cellWidth * 100) / tableWidth).toFixed(2);
            // eslint-disable-next-line no-param-reassign
            cell.style.width = `${relativeCellWidth}%`;
          } else {
            // If column width has not been set explicitly, set remaining columns to equal width.
            const relativeCellWidth = ((columnWidth * 100) / tableWidth).toFixed(2);
            // eslint-disable-next-line no-param-reassign
            cell.style.width = `${relativeCellWidth}%`;
          }
        });
      });
    }
  });

  return unescape(parsedHtml.body.innerHTML);
};

export default updateTableColumnsWidth;
